import FavouritesPageContent from '../components/Favourites/Favourites.js';

const FavouritesPage = () => {
  return <FavouritesPageContent />;
};

export default FavouritesPage;
